import type React from 'react';

import { Button } from '@change/ds-core-ui';
import { ShareIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core-react/i18n';

import { useIsMobile } from '#src/app/shared/hooks/userAgent';

import { usePhoto } from '../../hooks/photo';

import { usePetitionHeadingMobile } from './hooks/usePetitionHeadingMobile';

export const NativeShareMobile: React.FC = () => {
	const photo = usePhoto();
	const isMobile = useIsMobile();
	const { data } = usePetitionHeadingMobile();
	const ShareAction = data.shareAction?.ShareAction;

	return (
		<div
			className="sticky top-0 z-29 flex h-0 justify-end"
			data-testid="native-share-mobile"
			data-qa="native-share-mobile"
		>
			{isMobile && photo && ShareAction && (
				<div className="block md:hidden">
					<ShareAction>
						<Button
							aria-label="mobileNativeShare"
							iconOnly
							leadingIcon={<ShareIcon />}
							variant="tertiary"
							data-qa="native-share-button"
							data-testid="native-share-button"
							className="mt-4 mr-4 h-[50px] min-h-[50px] w-[50px] min-w-[50px] rounded-full border-0 bg-white p-[11px] shadow-[0px_2px_12px_0px_rgba(58,41,62,0.25)]"
						>
							<Translate value="corgi.petition_gamma.share.mobile_native_share" />
						</Button>
					</ShareAction>
				</div>
			)}
		</div>
	);
};
